import React from 'react';
import { cn } from '../../../utils/cn';

const DeviceCard = ({ 
  children, 
  variant = 'default',
  size = 'base',
  isActive = false,
  isHovered = false,
  onClick,
  className,
  ...props 
}) => {
  const variants = {
    default: 'bg-white border-gray-200',
    interactive: 'bg-white border-gray-200 hover:border-blue-300 hover:shadow-lg cursor-pointer',
    active: 'bg-white border-green-400 shadow-md',
    glass: 'bg-white/80 backdrop-blur-sm border-white/20'
  };

  const sizes = {
    sm: 'p-4 rounded-lg',
    base: 'p-5 rounded-xl', 
    lg: 'p-6 rounded-2xl'
  };

  const activeStyles = isActive ? 'border-green-400 shadow-green-100 shadow-lg' : '';
  const hoverStyles = isHovered && variant !== 'interactive' ? 'shadow-lg transform -translate-y-1' : '';

  return (
    <div
      className={cn(
        // Base styles
        'border transition-all duration-300 ease-out',
        'shadow-sm hover:shadow-md',
        
        // Variant styles
        variants[variant],
        
        // Size styles
        sizes[size],
        
        // State styles
        activeStyles,
        hoverStyles,
        
        // Custom className
        className
      )}
      onClick={onClick}
      {...props}
    >
      {children}
    </div>
  );
};

export default DeviceCard;